import { render, staticRenderFns } from "./ObraAuthorCard.vue?vue&type=template&id=501fbf2e"
import script from "./ObraAuthorCard.vue?vue&type=script&lang=js"
export * from "./ObraAuthorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports